import React from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

interface SidebarLinkProps {
	href?: string
	children: React.ReactNode
}

const SidebarLink = ({ children, href = '' }: SidebarLinkProps) => {
	const pathname = usePathname()

	const active = pathname === href

	return (
		<Link href={href} passHref>
			<div
				className={`flex items-center text-gray-800 font-bold px-4 py-2 mt-2 ${
					active ? 'bg-white rounded-md drop-shadow-md' : ''
				}`}
			>
				{children}
			</div>
		</Link>
	)
}

export default SidebarLink
